const teamMembers = [
  { server: 'Frostmane', name: 'Paddlin' },
  { server: 'Frostmane', name: 'Whoasked' },
  { server: 'Ner\'zhul', name: 'Yokoyama' },
  { server: 'Ner\'zhul', name: 'Eremes' },
  { server: 'Frostmane', name: 'Kardoroth' },
  { server: 'Korgath', name: 'Jazzbeams' },
  { server: 'Frostmane', name: 'Meanssa' },
  { server: 'Proudmoore', name: 'Pugchimp' },


];
export default teamMembers